// src/Components/EmployeeList.jsx
import React from 'react';
import styles from '../Pages/EmployeeManagement.module.css';

const EmployeeList = React.memo(({ employees, onEdit, onDelete }) => {
  
  if (!employees || employees.length === 0) {
    return (
      <p className={styles.emptyMessage}>No hay empleados registrados en esta página.</p>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <table className={styles.employeeTable}>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Correo</th>
            <th>Puesto</th>
            <th>Teléfono</th>
            <th className={styles.actionsHeader}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {employees.map(emp => (
            <tr key={emp.ID || emp.id} className={styles.employeeTableRow}>
              <td>{emp.Name || emp.name || '—'}</td>
              <td>{emp.Last_name || emp.last_name || '—'}</td>
              <td>{emp.Email || emp.mail || '—'}</td>
              <td>{emp.Position || emp.position || '—'}</td>
              <td>{emp.Number_phone || emp.tel_number || '—'}</td>
              <td className={styles.actionsCell}>
                <button
                  onClick={() => onEdit(emp)}
                  className={styles.buttonEdit}
                >
                  Editar
                </button>
                <button
                  onClick={() => onDelete(emp.ID || emp.id)}
                  className={styles.buttonDelete}
                >
                  Desactivar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default EmployeeList;